var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPayrollData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 802,
    height: 126,
    viewBox: "0 0 802 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M681.755 46.8646C693.345 46.8646 704.935 46.8646 716.526 46.8646C717.412 46.8646 731.731 45.3049 732.52 47.8691C735.211 56.6144 734.607 66.2024 734.607 75.2222C734.607 86.4906 734.607 97.759 734.607 109.027C734.607 114.15 718.688 111.539 715.212 111.539C708.464 111.539 701.716 111.539 694.968 111.539C689.177 111.539 681.589 113.002 676.191 110.843",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M681.751 46.8674C677.65 49.8826 675.227 50.2726 672.865 55.2125C671.897 57.2358 672.71 61.0083 672.71 63.1712C672.71 68.9663 672.71 74.7615 672.71 80.5566C672.71 86.1458 672.71 91.7349 672.71 97.324C672.71 100.904 672.71 104.484 672.71 108.064C672.71 111.073 674.289 110.846 676.883 110.846",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M734.664 77.8643C727.986 77.4087 721.794 75.3436 715.034 75.6287C709.964 75.8426 711.537 83.3922 711.537 87.4693C711.537 92.4581 717.708 90.5329 720.816 90.5329C724.576 90.5329 728.335 90.5329 732.094 90.5329",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M678.273 46.8657C700.506 43.0408 722.554 38.7663 744.338 32.9573",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M744.341 32.9573C746.576 47.2031 745.036 62.5847 745.036 77.0391C745.036 82.7313 745.036 88.4234 745.036 94.1156C745.036 100.625 743.728 99.7175 737.387 99.7175",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M785.129 48.176C785.286 53.7246 785.736 59.3542 787.156 64.7324C787.833 67.2976 787.777 69.9422 788.433 72.5038C788.982 74.6519 789.184 76.3581 789.184 78.5858",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M776.586 60.0805C773.685 59.9171 770.657 60.6396 769.491 63.5644C769.014 64.7635 768.992 66.3357 770.509 66.7304C773.331 67.4651 776.906 65.5645 779.32 67.6205C780.154 68.3311 780.573 69.4628 780.591 70.5322C780.615 71.8501 779.919 72.4068 778.659 72.7827C776.723 73.3602 774.55 73.135 772.556 73.126C771.883 73.123 771.176 73.1496 770.509 73.037C770.136 72.9741 770.236 72.7319 770.178 72.4394",
    stroke: "#FB7C51",
    strokeWidth: 1.32115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M771.32 55.3362C773.956 60.3225 775.218 65.621 775.936 71.179C776.309 74.066 776.453 77.127 777.156 79.9395",
    stroke: "#FB7C51",
    strokeWidth: 1.32115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 742.969,
    y: 56.3518,
    width: 4.2248,
    height: 24.8199,
    fill: "#FBFBFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M733.77 57.9728C750.137 52.3009 768.518 51.3461 785.466 48.512",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M734.445 91.4259C737.095 86.1263 742.953 83.251 748.261 81.3644C753.226 79.5997 758.336 80.3175 763.391 81.477C768.159 82.5707 773.085 83.9548 778.014 83.9548C782.024 83.9548 784.699 82.2161 787.831 79.9377",
    stroke: "#FB7C51",
    strokeWidth: 2.64229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M755.312 51.4769C756.278 50.1454 757.121 49.4999 758.73 49.1286C759.484 48.9546 760.327 48.8771 761.043 48.5679C762.28 48.0334 763.314 47.4449 764.688 47.2535C769.641 46.5638 774.631 46.9917 779.548 45.9743C783.37 45.1836 787.18 44.2449 791.027 43.591C792.401 43.3573 793.777 43.0698 795.145 42.8024C796.026 42.6303 796.438 42.3065 796.477 43.556C796.51 44.6336 796.375 45.7435 796.512 46.8154C796.605 47.5412 796.985 48.169 797.09 48.8921C797.202 49.6649 797.29 50.4141 797.458 51.1789C798.392 55.44 799.505 59.7156 799.981 64.0592C800.313 67.0804 800.577 70.0292 800.577 73.0666C800.577 73.4353 800.893 76.7173 800.507 76.9219C800.115 77.1303 799.62 76.9996 799.175 76.992C797.597 76.9648 796.011 76.9393 794.435 76.8518C793.142 76.78 791.879 76.4485 790.589 76.3962C789.746 76.362 789.378 76.5448 789.222 75.6076",
    stroke: "#FB7C51",
    strokeWidth: 1.32115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M599.275 111.291C568.3 123.986 496.446 138.864 456.838 96.8184C407.327 44.2616 104.5 -66.0001 0.5 57.9999",
    stroke: "#FB7C51",
    strokeDasharray: "7 7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M697.532 111.289C662.493 130.332 585.923 121.9 598.848 100.779C621.23 85.0164 601.055 116.226 598.848 111.497",
    stroke: "#FB7C51",
    strokeDasharray: "7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPayrollData);
export default __webpack_public_path__ + "static/media/noPayrollData.6b5fe7709c3fac6e1602c6e0623e4e86.svg";
export { ForwardRef as ReactComponent };